export interface Command {
  execute(): void;
}

export interface CommandOfT<T> extends Command {
  execute(): T;
  undo(): T;
}
